// extracted by mini-css-extract-plugin
module.exports = {"crumb":"_0fce717cdb--crumb--qf_Hs"};